import { Icon } from "leaflet"
import React, { Component } from "react";
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import {
    Container,Row,  Col,  Button,  Card,  CardBody,  CardTitle,  Modal,  ModalHeader,
      Input, CardFooter,Spinner, CardHeader,InputGroup} from "reactstrap"
import { MDBDataTable } from "mdbreact"
import ReactSelect from 'react-select'
import {components} from 'react-select'
import makeAnimated from 'react-select/animated';
import axios from 'axios'
import { format } from 'date-fns';
import  { Redirect } from 'react-router-dom'
import {PDFDownloadLink } from '@react-pdf/renderer';
import ModalMessage from "../pages/messages/ModalMessage"
import Flatpickr from "react-flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js";

import $ from "jquery";
import url from "../../common/api"
import urlFile from "../../common/ApiFile"
import {getLanguageList} from "../../services/langueService.js"
import {getThematiqueList} from "../../services/thematiqueService.js"
import {getFormatList} from "../../services/formatService.js"
import {getUniteAdministrativeList} from "../../services/uniteAdministrativeService.js"
import {getTypeRessourceList} from "../../services/typeRessourceService.js"
import {getTypeSystemeIrrigueList} from "../../services/systemeIrrigueService.js"
import {getPaysList} from "../../services/paysService.js"
import {addMotCle,getMotCleList} from "../../services/motCleService.js"
import {addAuteur,getAuteurList} from "../../services/auteurService.js"
import DocumentPdf from "./Document"
import CreatableSelect from 'react-select/creatable';
import {getQueries} from "../../queries/getQueries.js";
import {postQueries} from "../../queries/postQueries.js"
import {removeElement,updateVote,removeElements,updateRessource,
  removeUniteAdministrativeInRessource,removeSousTypeInRessource} from "../../services/ressourceService"
import Confirmer from "pages/Dashboard/Confirmer";
import {deleteQueries} from "../../queries/deleteQueries.js";
import {updateImage,updatePjointe} from "../../services/fileService"
import { registerUserFailed } from './../../store/auth/register/actions';
import profile from './../../store/auth/profile/reducer';
import ReactStars from "react-rating-stars-component";
import { initial } from "lodash";
// const Menu = props => {
//   const optionSelectedLength = props.getValue().length || 0;
//   return (
//     <components.Menu {...props}>
//       {optionSelectedLength < 5 ? (
//         props.children
//       ) : (
//         <div style={{ margin: 15 }}>Vous avez atteint le nombre maximum de mots-clé</div>
//       )}
//     </components.Menu>
//   );
// };

class DetailRessource extends Component {
  constructor(props) {
    super(props)
  
    this.handleDeleteLocalisation.bind(this)
    this.handleDeleteLangue.bind(this)
    this.handleDeleteMotCle.bind(this)
    this.handleDeleteThematique.bind(this)
    this.handleDeleteSysteme.bind(this)
    this.handleDeleteUnite.bind(this)
    this.handleDeleteProfile.bind(this)
    //check
    this.handleCheckLocalisation.bind(this)
    this.handleCheckLangue.bind(this)
    this.handleCheckMotCle.bind(this)
    this.handleCheckThematique.bind(this)
    this.handleCheckAuteur.bind(this)
    this.handleCheckSysteme.bind(this)
    this.handleCheckSousSysteme.bind(this)
    this.handleCheckUnite.bind(this)
    this.handleDeleteImage.bind(this)
    this.removeFile.bind(this)
    this.handleDeletePjointe.bind(this)
    this.handleVue.bind(this)
    this.handleDateInterval.bind(this)
    this.handleChangeProfile.bind(this);
    this.handleChangeType.bind(this)

   // this.handleUpdateThematique(this)
    this.state = {ok:"", ressource:{},systeme:[],auteur:[],unite:[],sous_type_ressource:[],langue:[],thematique:[],auteur:[],auteurs:[],mot:[],video:"",image:[],pjointe:[],localite:[],
    formats:[],langues:[],unites:[],auteurs:[], irrigues:[],sous_type_ressources:[],profiles:[],motcles:[],thematiques:[],type_ressources:[],localisations:[],url:"",
    defaultDateDebut:new Date(),defaultDateFin:new Date(),dateDebut:"",dateFin:"",idRessource:parseInt(sessionStorage.getItem("idressource")),
    checkMot:[],checkNewMot:[],checkAcces:[],checkAuteur:[],checkNewAuteur:[],checkSousTypeRessource:[],checkThematique:[],checkAuteur:[],checkLangue:[],checkLocalisation:[],checkSysteme:[],checkUnite:[],
    thematique_data:[],auteur_data:[],sous_type_ressource_data:[],systeme_data:[],langue_data:[],mot_data:[],unite_data:[],chargement:false,hide:"block",
    imgs_attributes:[],pjointes_attributes:[],titre:"test",type:props.type,dateD:"",dateF:"",profiles_attributes:[],public_id:0,profile:[],
    show:false,
    success:true,
    data_ressource_update:{},
    message:"La ressource a été modifiée avec succès !",
    titre:"Message modification  de ressource", 
    boutton:"OK",
    acces:[],
    date_edition:new Date(),
    validate_update:false,
    chargement_data:false, 
    accept_update:true,
    remove_data:{} ,
    index:props.index ,   
    profile_user:JSON.parse(sessionStorage.getItem("profileAuthAshia")),    
    entriesLabelList: ["5", "10", "20", "50", "100"],
    vote:0,
    vote_id:0,
    votes:[],
    commentaire:"",
    commented:true,
    vote_exist:false,
    vote_avg:"",
    nbr_vue:0,
    text_retour:"Retour"
    }

  }

  handleDroit=()=>{
    // vote
    $("#submiting").hide()

    //droit

    $(".owener").hide()
    $("#profiles").hide()
    $("#profile").hide()
    //
    $("#date").hide()
    $("#editerlien").hide()
    $("#editerdate").hide()
    $("#ddpe").hide()
    $("#dfpe").hide()
    
    //Tableaux
    $("#typesystemeirrigation").hide()
    $("#soustypesystemeirrigation").hide()
    $("#typederessource").hide()
    $("#langue").hide()
    $("#motcle").hide()
    $("#localisation").hide()
    $("#thematique").hide()
    $("#auteur").hide()
    $("#uniteadministrative").hide()

    $("#show-tsi").hide()
    $("#show-stsi").hide()
    $("#show-langue").hide()
    $("#show-motcle").hide()
    $("#show-localisation").hide()
    $("#show-thematique").hide()
    $("#show-auteur").hide()
    $("#show-acces").hide()
    $("#show-ua").hide()
    $("#show-lien").hide()
    
    //Bouttons
    $("#bouttonmodifier").hide()

    //Block des input
    $("#show-image").hide()
    $("#show-video").hide()
    $("#show-pj").hide()

    $("#show-format").hide()
    $("#valideState").hide()
    $("#show-ok-format").hide()
 
    $("#show-type-ressource").hide()
    $("#valideRessource").hide()
    $("#show-ok-tr").hide()

    $("#show-sous-type-ressource").hide()
    $("#valideRessource").hide()
    $("#show-ok-str").hide()
    
  }


  handleChargeFile=()=>{
    //this.setState({chargement:false})
    var id=sessionStorage.getItem("idressource")
    fetch(url+"ressources/"+id)
    .then((response) => response.json())
    .then((data) => {
        $(".owener").show()
        data.images.map(
            (element,idx)=>{
                this.setState({image:[...this.state.image,{id:element.id,name:element.file,file:urlFile.image+"/"+element.file}]})
            }
        )
        data.pjointes.map(
            (element,idx)=>{

                taille=parseInt(element.taille)/1024
                this.setState({pjointe:[...this.state.pjointe,{id:element.id,name:element.file,taille:taille+" KO",nom:element.file.split('.')[0].split('-')[1],file:urlFile.image+"/"+element.file,type:element.file.split('.')[1]}]})
               
            }
        )
    })

  }

  handleVue=(data)=>{
    
    
    const requestOptions = {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json','Accept': 'application/json' },
        body: JSON.stringify(data)
    };
    if(data?.nombre_vue){
      this.setState({nbr_vue:parseInt(data?.nombre_vue)})
      console.log("nombre vue",data?.nombre_vue)
    }
    
    var id=sessionStorage.getItem("idressource")
    fetch(url+"ressources/"+id,requestOptions)
    .then((response) => response.json())
    .then((data) => {
      
    })

  }


  componentDidMount(){
    sessionStorage.setItem("sis-session",900000)
    var id=sessionStorage.getItem("idressource")
    $(".owener").hide()
    $(".owener2").hide()
    $("#profile").hide()
    if(this.state.index===true){
      $("#droit").hide()
      $("#droit_d").hide()
      this.setState({text_retour:"Accueil"})
    }
    this.setState({hide:"none"})
    var taille=0
   
    //get list
   

    axios.get(url+"ressources/"+id)
    //.then((response) => response.json())
    .then(res => {
        const data=res.data
        var votes=data?.votes

        const my_vote=data?.votes.find(el=>el.user_id==JSON.parse(sessionStorage.getItem("authAshia"))?.id)
        console.log("vote",my_vote)
        if(my_vote){
          this.setState({vote_exist:true,vote:my_vote.etoile,commentaire:my_vote.description,vote_id:my_vote.id,commented:false})
        }

        this.setState({chargement:true})
        this.handleDroit()
        this.setState({ressource:data,votes:data.votes})
        console.log("ress",data)
      
        data.type_ressource.sous_type_ressources.map((el)=>{
            this.setState({sous_type_ressources:[...this.state.sous_type_ressources,{value:el.id,label:el.libelle}]})
        })
        this.setState({systeme:data.type_systeme_irrigues,sous_type_ressource:data.sous_type_ressources})
        this.setState({langue:data.langues})
        this.setState({acces:data.profiles})
        this.setState({unite:data.unite_administratives})
        this.setState({thematique:data.thematiques})
        this.setState({mot:data.mot_cles})
        this.setState({auteur:data.auteurs})
        this.setState({localite:data.pays})
        this.setState({url:data.url})
        this.setState({defaultDateDebut:Date.parse(data.date_debut_publication.split("/")[2]+"-"+data.date_debut_publication.split("/")[0]+"-"+data.date_debut_publication.split("/")[1])})
        this.setState({defaultDateFin:Date.parse(data.date_fin_publication.split("/")[2]+"-"+data.date_fin_publication.split("/")[0]+"-"+data.date_fin_publication.split("/")[1])})


        data.pays.map((val,idx)=>{
          val.unite_administratives.map((el,id)=>{
            this.setState({unites:[...this.state.unites,{value:el.id,label:el.libelle}]})
          })
        })
        
        let vote_avg=0
        data.votes.map((val,idx)=>{
          vote_avg=parseInt(val.etoile)+vote_avg
          votes[idx]["etoile"]= <ReactStars
              count={5}
              edit={false}
              value={votes[idx]["etoile"]}
              size={24}
              activeColor="#ffd700"
        />
         console.log("avg",vote_avg)
          const result=vote_avg/data.votes.length
          if(idx==data.votes.length-1){
            const avg=<ReactStars
            count={5}
            edit={false}
            value={result}
            size={48}
            activeColor="#ffd700"
         />
            console.log("result",result)
            this.setState({votes})
            this.setState({vote_avg:avg})
          }
         
        })




        // nombre de vue
        this.handleVue( {
            nombre_vue:parseInt(data.nombre_vue)+1
        } )


        $("#nom").val(data.nom)
        $("#url").val(data.url)
        $("#description").val(data.description)

        $("#date_debut").val(data.date_debut_publication)
        $("#date_fin").val(data.date_fin_publication)

        $("#date_edition").val(data.date_edition)

        const date1= data.date_edition.split("T")[0]
        const date2= data.date_fin_publication.split("T")[0]

        const dateD=date1.split("-")[2]+"/"+date1.split("-")[1]+"/"+date1.split("-")[0]
        const dateF=date2.split("-")[2]+"/"+date2.split("-")[1]+"/"+date2.split("-")[0]

         this.setState({dateD:dateD,date_edition:data.date_edition,dateF:dateF})
       
        if(data.video==""){
          //$("#video").css("display","none")
        }

        
        if(this.state.index===true){
          $("#droit").hide()
          $("#droit_d").hide()
        }

        data.pjointes.map(
            (element,idx)=>{
                
                taille=parseInt(element.taille)/1024
                this.setState({pjointe:[...this.state.pjointe,{id:element.id,name:element.file,taille:taille+" KO",nom:element.file.split('.')[0].split('-')[1],file:urlFile.image+"/"+element.file,type:element.file.split('.')[1]}]})
                // if(parseInt(element.taille)<1024){
                //   taille=parseInt(element.taille)/1024
                //   this.setState({pjointe:[...this.state.pjointe,{taille:taille+"KO",nom:element.file.split('.')[0].split('-')[1],file:"http://localhost/SIS/fichiers/data/"+element.file,type:element.file.split('.')[1]}]})
                // }
                // if(parseInt(element.taille)>=1024){
                //     taille=parseInt(element.taille)/1024
                //     this.setState({pjointe:[...this.state.pjointe,{taille:taille+"MO",nom:element.file.split('.')[0].split('-')[1],file:"http://localhost/SIS/fichiers/data/"+element.file,type:element.file.split('.')[1]}]})
                //   }
               

               
            }
        )

        data.images.map(
            (element,idx)=>{
                this.setState({image:[...this.state.image,{id:element.id,name:element.file,file:urlFile.image+"/"+element.file}]})
            }
        )
        try{
         $("#format").val(data.le_format.libelle)
        }catch(e){

        }
        try{
            $("#type_ressource").val(data.type_ressource.libelle)
           }catch(e){
   
           }
        try{
            $("#format").val(data.format.libelle)
           }catch(e){
   
        }   
        try{
            this.setState({video:data.video.replace("watch?v=","embed/")})
           }catch(e){
   
        }
      })

      //chargement des données
   
  }

  
  handleChargeAll=()=>{
   
    const data=this.state.ressource
    this.setState({systeme:data.type_systeme_irrigues,sous_type_ressource:data.sous_type_ressources})
    this.setState({langue:data.langues})
    this.setState({acces:data.profiles})
    this.setState({unite:data.unite_administratives})
    this.setState({thematique:data.thematiques})
    this.setState({mot:data.mot_cles})
    this.setState({auteur:data.auteurs})
    this.setState({localite:data.pays})
    this.setState({url:data.url})
    this.setState({defaultDateDebut:Date.parse(data.date_debut_publication.split("/")[2]+"-"+data.date_debut_publication.split("/")[0]+"-"+data.date_debut_publication.split("/")[1])})
    this.setState({defaultDateFin:Date.parse(data.date_fin_publication.split("/")[2]+"-"+data.date_fin_publication.split("/")[0]+"-"+data.date_fin_publication.split("/")[1])})


    
    $("#nom").val(data.nom)
    $("#url").val(data.url)
    $("#description").val(data.description)

    $("#date_debut").val(data.date_debut_publication)
    $("#date_fin").val(data.date_fin_publication)

    $("#date_edition").val(data.date_edition)

    const date1= data.date_edition.split("T")[0]
    const date2= data.date_fin_publication.split("T")[0]

    const dateD=date1.split("-")[2]+"/"+date1.split("-")[1]+"/"+date1.split("-")[0]
    const dateF=date2.split("-")[2]+"/"+date2.split("-")[1]+"/"+date2.split("-")[0]

     this.setState({dateD:dateD,date_edition:data.date_edition,dateF:dateF})

     try{
      $("#format").val(data.le_format.libelle)
     }catch(e){

     }
     try{
         $("#type_ressource").val(data.type_ressource.libelle)
        }catch(e){

        }
     try{
         $("#format").val(data.format.libelle)
        }catch(e){

     }   
     try{
         this.setState({video:data.video.replace("watch?v=","embed/")})
        }catch(e){

     }





  }


  handleRetour=()=>{
    if(this.state.index===true){
        $('#block_detail_ressource').hide()
        $('#acceuil-link').show()
        $('#block_page_acceuil').show()
        return 
    }else{
 
    this.setState({ok: <Redirect to='/liste-ressource'  />});
    return
    }
  }

  
  handleChargeMotCle=()=>{
    getMotCleList().then(e=>
      {
        let mot1 = this.state.mot.map(val => { return val.id});
       
        let mot2 = e?.filter(itemX => !mot1.includes(itemX.value));
       
        this.setState({motcles:mot2})
      }
    )
  }
  handleChargeLangue=()=>{ 
    getLanguageList().then(e=>{
      let langue1 = this.state.langue.map(val => { return val.id});
        
      let langue2 = e?.filter(itemX => !langue1.includes(itemX.value));
      
      this.setState({langues:langue2})
    })
  }


  handleChargeUnite=()=>{
    //this.handleChargeUnite()
    let auteur1 = this.state.unite.map(val => { return val.id});
   
    let auteur2 = this.state.unites.filter(itemX => !auteur1.includes(itemX.value));
   
    this.setState({unites:auteur2})
   
 }

  handleChargeLocalisation=()=>{  
    getPaysList().then(e=>
      {
        let pay1 = this.state.localite.map(val => { return val.id});
     
        let pay2 = e?.filter(itemX => !pay1.includes(itemX.value));
    
        this.setState({localisations:pay2})
      }
      )
  }
  handleChargeSysteme=()=>{
    getTypeSystemeIrrigueList().then(e=>
      {
       
        let auteur1 = this.state.systeme.map(val => { return val.id});
      
     
       
      let auteur2 = e?.filter(itemX => !auteur1.includes(itemX.value));

     

      this.setState({irrigues:auteur2})
      
      })

  }
  handleChargeThematique=()=>{
    getThematiqueList().then(e=>
      {
        let auteur1 = this.state.thematique.map(val => { return val.id});
       
        let auteur2 = e.filter(itemX => !auteur1.includes(itemX.value));
       
        this.setState({thematiques:auteur2})
        
      }
      )  
  }
  handleChargeAuteur=()=>{
    getAuteurList().then(e=>
      {
        let auteur1 = this.state.auteur.map(val => { return val.id});
  
        let auteur2 =e.filter(itemX => !auteur1.includes(itemX.value));
  
        this.setState({auteurs:auteur2})
        
      }
        )
  }

  handleCharge=()=>{

    getFormatList().then(e=>this.setState({formats:e}))
    getTypeRessourceList().then(e=>this.setState({type_ressources:e}))

    this.handleChargeMotCle()
    this.handleChargeAuteur()
    this.handleChargeLangue()
    this.handleChargeLocalisation()
    this.handleChargeSysteme()
    this.handleChargeUnite()
    this.handleChargeThematique()

  

    getQueries("profiles").then(e=>{
      const data=e
      try{
        this.setState({public_id:data.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase())[0].id,
        profiles_attributes:[{"profile_id":data.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase())[0].id}]
      })
        
       }catch(error){
  
       }
       var pub=data.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase())
       let acces= _.sortBy(this.state.acces.concat(pub), 'id')

       let pay1 = acces.map(val => { return val.id});
       
       let pay2 = data.filter(itemX => !pay1.includes(itemX.id));
     
       pay2.map((element,idx) =>{
        this.setState({profile:[...this.state.profile,{value:element.id,label:element.libelle}]})
      })

    

    })
  
  
  }



    handleImage=()=>{
        $("#show-image").show()
    }

    handleVideo=()=>{
        $("#show-video").show()
        $("#video").val(this.state.video)
    }

    handlePieceJointe=()=>{
        $("#show-pj").show()
    }


    

      removeFile=(Url,data)=>{
        
        const requestOptions = {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json','Accept': 'application/json' }
        };
      
          fetch(url+Url,requestOptions)
          .then((response) => response.json())
          .then(response =>{console.log("ok,",response)
              this.setState({message:"Fichier supprimé avec suscces !"})
              this.setState({show:true,success:true});
              setTimeout(()=>
              window.location.reload(false)
            , 1000)
         } ,
         (error) => {


            //a revoir 
          $.ajax({
            type: "POST",
            url: url+'remove_file/remove.php',
            data: data,
            success: function(data){
                this.setState({message:"Fichier supprimé avec suscces !"})
                this.setState({show:true,success:true});
                setTimeout(()=>
                window.location.reload(false)
              , 1000)
            console.log("okk",data);
            },
            error: function(xhr, status, error){
              console.log("hh======<",error);
            }
           });

           this.setState({message:"Fichier supprimé avec suscces !"})
              this.setState({show:true,success:true});
              setTimeout(()=>
              window.location.reload(false)
            , 1000)


            console.log("erreur,",error)
         })

          //remove
          $.ajax({
            type: "POST",
            url: url+'remove_file/remove.php',
            data: data,
            success: function(data){
                this.setState({message:"Fichier supprimé avec suscces !"})
                this.setState({show:true,success:true});
                setTimeout(()=>
                window.location.reload(false)
              , 1000)
            console.log("okk",data);
            },
            error: function(xhr, status, error){
              console.log("hh======<",error);
            }
           });
      }


   
   
// remove 
    handleDeleteMotCle=(id)=>{
      this.setState({validate_update:true})
      var data={"ressource_id":this.state.idRessource,"mot_cle_id":id}
      console.log("data mot cle:",data)
      // this.remove(data,"ressource_mot_cle/delete")
      try{
        this.state.remove_data["ressource_mot_cle/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }catch(err){
        this.state.remove_data["ressource_mot_cle/delete"]=[]
        this.state.remove_data["ressource_mot_cle/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }
      // removeElement(data,"ressource_mot_cle/delete").then(data=>{
       
      // })
        this.setState({mot:this.state.mot.filter((data)=>data.id!==id)})
    }
    handleDeleteLangue=(id)=>{

      this.setState({validate_update:true}) 

        var data={"ressource_id":this.state.idRessource,"langue_id":id}

        try{
          this.state.remove_data["ressource_langue/delete"].push(data)
          this.setState({remove_data:this.state.remove_data})
        }catch(err){
          this.state.remove_data["ressource_langue/delete"]=[]
          this.state.remove_data["ressource_langue/delete"].push(data)
          this.setState({remove_data:this.state.remove_data})
        }
        
        // removeElement(data,"ressource_langue/delete").then(data=>{
          
        // })
       this.setState({langue:this.state.langue.filter((data)=>data.id!==id)})
    }
    handleDeleteUnite=(id)=>{

      this.setState({validate_update:true})

        var data={"ressource_id":this.state.idRessource,"unite_administrative_id":id}

        try{
          this.state.remove_data["ressource_unite_administrative/delete"].push(data)
          this.setState({remove_data:this.state.remove_data})
        }catch(err){
          this.state.remove_data["ressource_unite_administrative/delete"]=[]
          this.state.remove_data["ressource_unite_administrative/delete"].push(data)
          this.setState({remove_data:this.state.remove_data})
        }
    
        // removeElement(data,"ressource_unite_administrative/delete").then(data=>{
          
        // })

        this.setState({unite:this.state.unite.filter((data)=>data.id!==id)})
      }
    handleDeleteProfile=(id)=>{

      this.setState({validate_update:true})

      var data={"ressource_id":this.state.idRessource,"profile_id":id}
     
      if(this.state.acces.length>=2){
        this.setState({acces:this.state.acces.filter((data)=>data.id!==id)})
        try{
          this.state.remove_data["ressource_profile/delete"].push(data)
          this.setState({remove_data:this.state.remove_data})
        }catch(err){
          this.state.remove_data["ressource_profile/delete"]=[]
          this.state.remove_data["ressource_profile/delete"].push(data)
          this.setState({remove_data:this.state.remove_data})
        }
        
        // removeElement(data,"ressource_profile/delete").then(data=>{
        
        // })
      }else{
        this.setState({message:"Tous les profils ne peuvent être supprimés !"})
        this.setState({show:true,success:false});
      }
     
    }
    handleDeleteLocalisation=(id)=>{

      this.setState({validate_update:true})

        var data={"ressource_id":this.state.idRessource,"pay_id":id}
        try{
          this.state.remove_data["ressource_pay/delete"].push(data)
          this.setState({remove_data:this.state.remove_data})
        }catch(err){
          this.state.remove_data["ressource_pay/delete"]=[]
          this.state.remove_data["ressource_pay/delete"].push(data)
          this.setState({remove_data:this.state.remove_data})
        }
      
          // removeElement(data,"ressource_pay/delete").then(data=>{
          
          // })
          this.setState({localite:this.state.localite.filter((data)=>data.id!==id)})

          //suprime unite admininstratives
          this.state.unite.map((el,idx)=>{
            const unite={"ressource_id":this.state.idRessource,"unite_administrative_id":el.id}

            try{
              this.state.remove_data["ressource_unite_administrative/delete"].push(unite)
              this.setState({remove_data:this.state.remove_data})
            }catch(err){
              this.state.remove_data["ressource_unite_administrative/delete"]=[]
              this.state.remove_data["ressource_unite_administrative/delete"].push(unite)
              this.setState({remove_data:this.state.remove_data})
            }
    
            // removeElement(unite,"ressource_unite_administrative/delete").then(data=>{
              
            // })
  
            this.setState({unite:this.state.unite.filter((data)=>data.id!==id)})
          })

         
      }
    handleDeleteSysteme=(id)=>{

      this.setState({validate_update:true})

      var data={"ressource_id":this.state.idRessource,"type_systeme_irrigue_id":id}

      try{
        this.state.remove_data["ressource_systeme_irrigue/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }catch(err){
        this.state.remove_data["ressource_systeme_irrigue/delete"]=[]
        this.state.remove_data["ressource_systeme_irrigue/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }
     
      // removeElement(data,"ressource_systeme_irrigue/delete").then(data=>{
        
      // })
      this.setState({systeme:this.state.systeme.filter((data)=>data.id!==id)})
    }
    handleDeleteSousType=(id)=>{

      this.setState({validate_update:true})

      var data={"ressource_id":this.state.idRessource,"sous_type_ressource_id":id}

      try{
        this.state.remove_data["ressource_sous_ressource/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }catch(err){
        this.state.remove_data["ressource_sous_ressource/delete"]=[]
        this.state.remove_data["ressource_sous_ressource/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }
 
      // removeElement(data,"ressource_sous_ressource/delete").then(data=>{
        
      // })
      this.setState({sous_type_ressource:this.state.sous_type_ressource.filter((data)=>data.id!==id)})
    }
    handleDeleteThematique=(id)=>{
      this.setState({validate_update:true})
      var data={"ressource_id":this.state.idRessource,"thematique_id":id}
      try{
        this.state.remove_data["ressource_thematique/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }catch(err){
        this.state.remove_data["ressource_thematique/delete"]=[]
        this.state.remove_data["ressource_thematique/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }
        
        // removeElement(data,"ressource_thematique/delete").then(data=>{
        
        // })
        this.setState({thematique:this.state.thematique.filter((data)=>data.id!==id)})
    }
    handleDeleteAuteur=(id)=>{
      this.setState({validate_update:true})
      var data={"ressource_id":this.state.idRessource,"auteur_id":id}
      try{
        this.state.remove_data["ressource_auteur/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }catch(err){
        this.state.remove_data["ressource_auteur/delete"]=[]
        this.state.remove_data["ressource_auteur/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }
      
       
        // removeElement(data,"ressource_auteur/delete").then(data=>{
        
        // })
        this.setState({auteur:this.state.auteur.filter((data)=>data.id!==id)})
    }
    handleDeleteImage=(id,file)=>{
        this.setState({validate_update:true})
        this.removeFile("images/"+id,{avatar:file})
       
        //this.setState({image:this.state.image.filter((data)=>data.id!==id)})
    }

    handleDeletePjointe=(id,file)=>{
        this.setState({validate_update:true})
        this.removeFile("pjointes/"+id,{avatar:file})
       
        //this.setState({pjointe:this.state.pjointe.filter((data)=>data.id!==id)})
    }


    // traitement de la suppression,
    handleDeleteActions=()=>{
      
      Object.keys(this.state.remove_data).map((element,idx)=>{
        removeElements(this.state.remove_data[element],element).then(data=>{
        
        })
      })
    }

      
  //check
  
  
  handleCheckMotCle=(data)=>{
    console.log("================>",data)
    var  tab=[]
    this.setState({checkMot:tab,checkNewMot:[],validate_update:true})
    this.handleChangeNew
    try{
      data.map((val,idx)=>{
        const mot=this.state.motcles.find(el=>el.value==val.value)
        if(mot){
          
          this.setState({checkMot:[...this.state.checkMot,{mot_cle_id:val.value}]})
        }else{
          
          this.setState({checkNewMot:[...this.state.checkNewMot,{"libelle":val.value}]})
        }
          
      })
    }catch(error){
      this.setState({checkNewMot:[],checkMot:[]})
    }
  }

  handleChangeNew = function (newValue, actionMeta) {
    console.group('Value Changed');
    console.log(newValue);
    console.log("action: " + actionMeta.action);
    console.groupEnd();
  };

  handleCheckLangue=(data)=>{
    var  tab=[]
    this.setState({checkLangue:tab,validate_update:true})
    try{
        data.map((val,idx)=>{
            this.setState({checkLangue:[...this.state.checkLangue,{langue_id:val.value}]})
        })

    }catch(error){
      this.setState({checkLangue:[]})
    }
    
  }
  handleCheckUnite=(data)=>{
    var  tab=[]
    this.setState({checkUnite:tab,validate_update:true})
    try{

        data.map((val,idx)=>{
            this.setState({checkUnite:[...this.state.checkUnite,{unite_administrative_id:val.value}]})
        })

    }catch(error){
      this.setState({checkUnite:[]})
    }
    
    }
  handleCheckLocalisation=(data)=>{
    var  tab=[]
    var unite=[]
    this.setState({checkLocalisation:tab,validate_update:true})
    try{
      data.map((val,idx)=>{

        val.unite_administratives.map((el)=>{
          unite=[...unite,{value:el.id,label:el.libelle}]
          this.setState({unites:unite})
        })


        this.setState({checkLocalisation:[...this.state.checkLocalisation,{pay_id:val.value}]})
      })
    }catch(error){   
      this.setState({checkLocalisation:[],unites:[]})
    }
  }

  handleCheckSysteme=(data)=>{
    var  tab=[]
    this.setState({checkSysteme:tab,validate_update:true})
    try{
      data.map((val,idx)=>{
        this.setState({checkSysteme:[...this.state.checkSysteme,{type_systeme_irrigue_id:val.value}]})
      })
    }catch(error){ 
      this.setState({checkSysteme:[]})  
    }
  }

  handleCheckSousSysteme=(data)=>{
    var  tab=[]
    this.setState({checkSousTypeRessource:tab,validate_update:true})
    try{
     
      data.map((val,idx)=>{
        this.setState({checkSousTypeRessource:[...this.state.checkSousTypeRessource,{sous_type_ressource_id:val.value}]})
      
      })
    }catch(error){  
 
      this.setState({checkSousTypeRessource:[]})
    }
  }

  handleCheckThematique=(data)=>{
    var  tab=[]
    this.setState({checkThematique:tab,validate_update:true})
    console.log("tttt",data)
    try{
      data.map((val,idx)=>{
          this.setState({checkThematique:[...this.state.checkThematique,{thematique_id:val.value}]})
      })
    }catch(error){
      this.setState({checkThematique:[]})
    }
  }

  handleCheckAuteur=(data)=>{
    var  tab=[]
    this.setState({checkAuteur:tab,checkNewAuteur:tab,validate_update:true})
    console.log(" auteur",data)

    this.handleChangeNew
    try{
      data.map((val,idx)=>{
        const auteur=this.state.auteurs.find(el=>el.value==val.value)
        if(auteur){
          
          this.setState({checkAuteur:[...this.state.checkAuteur,{auteur_id:val.value}]})
        }else{
          
          this.setState({checkNewAuteur:[...this.state.checkNewAuteur,{"nom":val.value}]})
        }
          
      })
    }catch(error){
      this.setState({checkNewAuteur:[],checkAuteur:[]})
    }
  
   
  }
    

    // upadte 

  



    handleUpdateRessource=async()=>{
      $("#droit_spiner").hide()
      await this.setState({chargement_data:true,accept_update:false})

      var imageList=document.getElementById("image").files
      var pjList=document.getElementById("pieceJointe").files

      console.log("sous ressource",this.state.checkSousTypeRessource)

      // save new pjointe
      for(var i=0;i<pjList.length;i++){
        var formData = new FormData(); 
        formData.append( 
          "avatar", 
          pjList[i] 
        ); 
        updatePjointe(formData).then(data=>{})

        this.setState({message:"La ressource a été modifiée avec succès !"})
          
        // $("#initial").hide()
        // $("#chargementoo").show()
        
        setTimeout(()=>
          // window.location.reload(false)
          this.setState({show:true,success:true})
        , 13000)

        
        // $("#chargement").hide()
        // $("#initial").show()
        // this.setState({show:true,success:true});
      }

      // supprimer les elements concernés
      this.handleDeleteActions()

      var ressource={
        "description":$("#description").val(),
        "video":$("#video").val(),
        "url":$("#url").val(),
        "nom":$("#nom").val(),
        "date_edition":this.state.date_edition,
        "ressource_auteurs_attributes":_.uniqBy(this.state.checkAuteur, 'auteur_id'),
        "ressource_thematiques_attributes":_.uniqBy(this.state.checkThematique, 'thematique_id'),
        "ressource_pays_attributes":_.uniqBy(this.state.checkLocalisation, 'pay_id'),
        "ressource_unite_administratives_attributes":_.uniqBy(this.state.checkUnite, 'unite_administrative_id'),
        "ressource_langues_attributes":_.uniqBy(this.state.checkLangue, 'langue_id'),
        "ressource_mot_cles_attributes":_.uniqBy(this.state.checkMot, 'mot_cle_id'),
        "ressource_sous_ressources_attributes":_.uniqBy(this.state.checkSousTypeRessource, 'sous_type_ressource_id'),
        "ressource_systeme_irrigues_attributes":_.uniqBy(this.state.checkSysteme, 'type_systeme_irrigue_id'),
        "ressource_profiles_attributes":_.uniqBy(this.state.checkAcces, 'profile_id')
      }

      if(this.state.checkNewMot.length){
       
        addMotCle(this.state.checkNewMot,sessionStorage.getItem("idressource"))
      }
      
      if(this.state.checkNewAuteur.length){
        
        addAuteur(this.state.checkNewAuteur,sessionStorage.getItem("idressource"))
      }



      if($("#show-format option:selected").val()!=="0"){
        ressource["le_format_id"]=$("#show-format option:selected").val()
      }
     
      
      if($("#show-type-ressource option:selected").val()!=="0"){
        ressource["type_ressource_id"]=$("#show-type-ressource option:selected").val()

        
      // if($("#show-type-ressource option:selected").val()!==this.state.ressource?.type_ressource?.libelle){
      //   removeSousTypeInRessource(this.state.sous_type_ressource,this.state.idRessource).then(data=>{
      //   })
      // }
     
        
      }

      
      // removeUniteAdministrativeInRessource(this.state.unite,this.state.idRessource).then(data=>{

      // })

      
      /////////////////////////////
      /////////////////////////////

       
        // for(var i=0;i<pjList.length;i++){
        //   if(this.state.fileok){
        //     const formData = new FormData(); 
        //     console.log("file",formData) 
        //     // Update the formData object 
        //     formData.append( 
        //       "avatar", 
        //       pjList[i] 
        //     ); 
        //     const requestOptions = {
        //       method: 'POST',
        //       // mode: 'cors',
        //       // headers: {'Access-Control-Allow-Origin':'*' },
        //       body: formData
        //     }
        //   }else{
        //     $("#echecSauv").show()
        //     this.setState({message:"Veuillez choisir des fichiers de tailles < 2Mo "})
        //     $("#initial").show()
        //     $("#chargement").hide()
        //     this.setState({show:true,success:false});
        //   }
        // };

      /////////////////////////////////
      /////////////////////////////////

      for(var i=0;i<imageList.length;i++){
        var formData = new FormData(); 
         
        // Update the formData object 
        formData.append( 
          "avatar", 
          imageList[i] 
         
        );
        if(i==imageList.length-1){
          $("#initial").hide()
          this.setState({accept_update:false})

          //update ressource when image exist
          updateImage(formData).then(data=>{

            updateRessource(ressource).then(data=>{
              this.setState({chargement_data:false})
              this.handleVue( {
                nombre_vue:parseInt(this.state.nbr_vue)-1
              } )  
            })

            this.setState({message:"La ressource a été modifiée avec succès !"})

            // $("#initial").hide()
            // $("#chargementoo").show()
            
            setTimeout(()=>
              // window.location.reload(false)
              this.setState({show:true,success:true})
            , 13000)
            
            // $("#chargement").hide()
            // $("#initial").show()
            // this.setState({show:true,success:true});

          })
        }else{
          updateImage(formData).then(data=>{
              
          })
        }
      }

        //update ressource !width image
      if(!imageList.length){
        $("#initial").hide()
        this.setState({accept_update:false})

        updateRessource(ressource).then(data=>{
          console.log("data",data)

          this.handleVue( {
            nombre_vue:parseInt(this.state.nbr_vue)-1
          } )

          
        })

        // $("#initial").hide()
        // $("#chargementoo").show()
        
        setTimeout(()=>
          // window.location.reload(false)
          this.setState({show:true,success:true,chargement_data:false})
        , 13000)

        this.setState({message:"La ressource a été modifiée avec succès !"})
        
        // $("#chargement").hide()
        // $("#initial").show()
        // this.setState({show:true,success:true});
      }
    }

    handleModifierRessource=()=>{

      this.handleCharge()
      this.setState({accept_update:false})
  
      $(".owener-close").hide()
      $("#droit").hide()
      $("#droit_d").hide()

      setTimeout(()=>
      {
        this.setState({accept_update:true})
        this.setState({hide2:"none"})
        this.setState({hide:"block"})
        $(".owener").show()
        $(".show").show()
        document.getElementById("nom").readOnly = false;
        document.getElementById("url").readOnly = false;
        document.getElementById("description").readOnly = false;
        document.getElementById("type_ressource").readOnly = false;
        document.getElementById("format").readOnly = false;
      }
      , 3000)

        
       
       
      
     
     // this.handleCharge()
    }

    handleAnuler=()=>{
      this.setState({
        validate_update:false,
        accept_update:true,
        checkSysteme:[],
        checkThematique:[],
        checkUnite:[],
        checkLangue:[],
        checkLocalisation:[],
        checkMot:[],
        checkNewAuteur:[],
        checkSousTypeRessource:[],
        checkNewMot:[],
        checkAcces:[],
        hide:"none",
        remove_data:{}})

       this.handleChargeAll()
      $("#droit_spiner").show()

      $(".owener-close").show()
      $("#droit").show()
      $("#droit_d").show()
      $(".owener").hide()
      $(".show").hide()
      document.getElementById("nom").readOnly = true;
      document.getElementById("url").readOnly = true;
      document.getElementById("description").readOnly = true;
      document.getElementById("description").readOnly = true;
    }

  handleDateInterval= (date)=> {
    this.setState({dateD:""})
    // $("#editerdate").hide()
    // $("#date").show()
  
    try{ 
    
     this.setState({dateD:"",date_edition:date[0],validate_update:true})
    }catch(err){
      this.setState({date_edition:new Date()})
    }
    
    }

  handleTelechargeIncrement=()=>{
      // nombre de telechargement
      this.handleVue( {
          nombre_telecharge:parseInt(this.state.ressource.nombre_telecharge)+1
      } )
  }

  handleChangeText=()=>{
    this.setState({validate_update:true})
  }

  handleChangeType=(e)=>{
    var data=[]
    var type=[]
    this.setState({validate_update:true,sous_type_ressources:data})
    if(e.target.value!=0){
      setTimeout(()=>
      {
        this.state.type_ressources.find(val=>val.value==e.target.value)?.sous_types.map((el)=>{
          type=[...type,{value:el.id,label:el.libelle}]
          this.setState({sous_type_ressources:type})
        })
      }
      , 1)
     

    }else{
      this.setState({sous_type_ressources:data})
      
    }
  }


    handleChangeAcces = () => {
      this.setState({validate_update:true})
      if($("#acces option:selected").val()=="Privé"){
          $("#profiles").show()
      }else{
        $("#profiles").hide()
        this.setState({checkAcces:[{"profile_id":this.state.public_id}]})
      }
    }

    handleChangeProfile = (e) => {
    var data=[]
    this.setState({checkAcces:data,validate_update:true})
    console.log("===>>",e)
    try{
      e.map((element,idx) =>{
        this.setState({checkAcces:[...this.state.checkAcces.filter(x => x.profile_id != this.state.public_id),{"profile_id":element.value}]})
        console.log("===>>profile",element)
      })

    }catch(e){
      this.setState({checkAcces:data})
    }


    }

    handleValidate=()=>{
    
        this.setState({show:false})
        window.location.reload(false)

      
    }

   handleVote=()=>{
   
    $("#submiting").show()
    $("#initial").hide()


    var vote={
      "description":this.state.commentaire,
      "user_id":JSON.parse(sessionStorage.getItem("authAshia")).id,
      "etoile":this.state.vote,
    }
    if(!this.state.vote_exist){
      postQueries("votes",vote).then(e=>{
        const ressource={"ressource_votes_attributes":[{"ressource_id":this.state.idRessource,"vote_id":e.id}]}
        var vote=e
        updateRessource(ressource).then(data=>{
          
        vote["etoile"]= <ReactStars
                          count={5}
                          edit={false}
                          value={vote["etoile"]}
                          size={24}
                          activeColor="#ffd700"
                      />
       this.setState({votes:[...this.state.votes,vote],commented:false,vote_exist:true,commentaire:data.description,vote_id:data.id,vote:data.etoile})
        })
      })
    }else{
     
        updateVote(vote,this.state.vote_id).then(data=>{
          var init=data
          var voted=this.state.votes.filter(val=>val.id!==data.id)
          init["etoile"]= <ReactStars
                            count={5}
                            edit={false}
                            value={init.etoile}
                            size={24}
                            activeColor="#ffd700"
                          />
       this.setState({votes:[...voted,init],commented:false})
        })
    }
   
      

   }

   isValidNewOption = (inputValue, selectValue) => inputValue.length > 0 && selectValue.length < 2;

    Menu = props => {
    const optionSelectedLength = props.getValue().length || 0;
    return (
      <components.Menu {...props}>
        {optionSelectedLength < 2 ? (
          props.children
        ) : (
          <div style={{ margin: 15 }}>Vous avez atteint le nombre maximum de mots-clé</div>
        )}
      </components.Menu>
    );
  };

    
  handleValiderSuppression=()=>{
    document.getElementById("cls").click()
    const id=sessionStorage.getItem("idressource")
    deleteQueries("ressources/"+id).then(data=>{
      
    this.setState({ok: <Redirect to='/liste-ressource'  />});

      // this.setState({message:"Acteur supprimé avec succès!!",title:"Suppression d'acteur"})
      // this.setState({show:true,success:true});
    })
  }
  
  handleConfirme=()=>{
    document.getElementById("modale").click()
  }

  
   render() {
    const { pick } = this.state
    const animatedComponents = makeAnimated();
    const isValidNewOption = (inputValue, selectValue) => inputValue.length > 0 && selectValue.length < 5;
    var today = new Date();
    const Menu = props => {
      const optionSelectedLength = props.getValue().length || 0;
      return (
        <components.Menu {...props}>
          {optionSelectedLength < (5-parseInt(this.state.mot.length)) ? (
            props.children
          ) : (
            <div style={{ margin: 15 }}>Vous avez atteint le nombre maximum de mots-clé</div>
          )}
        </components.Menu>
      );
    };
    const vote = {
      columns: [
        {
          label: "Notation",
          field: "etoile",
          sort: "asc",
          width: 150,
        },
        {
          label: "Commentaire",
          field: "description",
          sort: "asc",
          width: 270,
        },
      ],
       rows:_.sortBy(this.state.votes, 'created_at').reverse()
      //rows:this.state.votes
    }
    return (
      <React.Fragment>
           {
            (this.state.chargement)?
                (<>
                    {this.state.ok}

                    <ModalMessage
                      show={this.state.show}
                      success={this.state.success}
                      boutton={this.state.boutton}
                      handleValidate={this.handleValidate}
                      message={this.state.message}
                      titre={this.state.titre}
                      onCloseClick={() => this.setState({ show: false })}
                   />
                     <Confirmer
                        bouton="Supprimer"
                        titre="Suppression de ressource"
                        message="Voullez-vous vraiment supprimer la ressource ?"
                        handleValider={this.handleValiderSuppression}
                    />

            <div className="page-content mb-3">
           
                <MetaTags>
                    <title>Détails de la ressource</title>
                </MetaTags>
                <div className="container-fluid ">
                {/* <Breadcrumbs title="Détails de la ressource" breadcrumbItem="Détails de la ressource" /> */}
                
                <Row>
                {!this.state.validate_update?
                  <Col md="4">
                    <Button onClick={this.handleRetour} style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}} >
                      {this.state.text_retour}
                    </Button>
                  </Col>:null
                }
                {
                this.state.profile_user?.droit_ressource?.modifier?
                  <Col md="8" >
                  {this.state.profile_user?.droit_expert?.supprimer?
                  <div id="droit_d">
                    <Button onClick={this.handleConfirme} className="btn btn-danger" style={{marginRight:"7px", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                        Supprimer la ressource
                    </Button>
                  </div>:null
                  }
                  <div id="droit">
                    <Button onClick={this.handleModifierRessource} style={{ marginRight:"5px",backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                      Modifier la ressource
                    </Button>
                  </div>
                  <div id="droit_spiner">
                  {
                    !this.state.accept_update?
                    <Button  id="spider"  style={{width:"150px",backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true">...</span>
                 </Button>:null
                   }
                   </div>
                  </Col>:null
                 }
                  
                  
                </Row>
                {this.state.validate_update?
                <Row>
                  <Col md="6">
                    <Button onClick={this.handleRetour} style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}} >
                      {this.state.text_retour}
                      </Button>
                    </Col>
                  <Col md="6" >
                 
                    {
                      this.state.chargement_data?
                      <Button  style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </Button>:
                      <Button id="initial" onClick={this.handleUpdateRessource} style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                        Appliquer la modification
                      </Button>
                    }
                     {/* {this.state.profile_user?.droit_expert?.supprimer?
                      <div >
                        <Button onClick={this.handleConfirme} className="btn btn-danger" style={{marginRight:"7px", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                            Supprimer la ressource
                        </Button>
                      </div>:null
                  } */}
                    
                  </Col>
                </Row>:null
                  }
                
            
                <hr/>

                <Row>
                
                  <Col md="12">
                  {/* borderColor:"#6A7172" */}
                    <Card className="show" id="show-pj" style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                      <CardBody>
                      <h5 >Pièce(s) jointe(s)</h5>
                        <Input
                            className="form-control"
                            type="file"
                            multiple 
                            placeholder="Pièce jointe"
                            id="pieceJointe"
                            onChange={this.handleChangeText}
                        />
                      </CardBody>
                    </Card>
                  </Col> 
                </Row>
                <Row className="mt-4 mb-4">
                    {/* {
                    (this.state.pjointe.length!=0)? */}
                    <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                            <CardTitle className="mb-1 h4"><h4> <i className="bx bx-paperclip bx-sm " style={{color:"#6A7172",lineHeight : '1'}}/> Pièce(s) jointe(s)</h4> </CardTitle>
                           
                            {/* <div className="text-center">
                                <div className="mb-1">
                                    
                                </div>
                            </div> */}

                            <div className="table-responsive mt-4">
                           {   
                           (this.state.pjointe.length!=0)?
                            <table className="table align-middle table-nowrap">
                                <thead>
                                    <tr>
                                        
                                        <th style={{ width: "30%" }}>

                                            NOM
                                        </th>
                                        <th style={{ width: "25%" }}>
                                            TYPE
                                        </th>
                                        <th style={{ width: "30%" }}>

                                            TAILLE
                                        </th>
                                        <th>
                                            TELECHARGER
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {
                                        (this.state.pjointe.length!=0)?
                                        (
                                           ( 
                                             this.state.pjointe.map(
                                                (element,idx)=>(
                                                    <tr>
                                                    
                                                    <td style={{ width: "30%" }}>

                                                      <p className="mb-0">{element.nom}</p>
                                                    </td>
                                                    <td style={{ width: "25%" }}>
                                                        <h5 className="mb-0">{element.type}</h5>
                                                    </td>
                                                    <td style={{ width: "30%" }}>

                                                        <p className="mb-0">{element.taille}</p>
                                                    </td>
                                                    <td style={{display:this.state.hide2}}>
                                                        <a href={element.file} download target="_blank" > <i className="bx bxs-download bx-sm  " style={{color:"#338C36"}}/> </a>
                                                       
                                                    </td>
                                                    <td style={{display:this.state.hide}}>
                                                      <a href={element.file} download target="_blank" > <i className="bx bxs-download bx-sm" style={{color:"#338C36"}}/> </a>
                                                      <a onClick={this.handleDeletePjointe.bind(this,element.id,element.name)}> <i className="bx bxs-trash bx-sm" style={{color:"#cc0003"}} /> </a>
                                                    </td>
                                                </tr>
                                                )
                                             )
                                           ) 
                                        ):null
                                    }
                                </tbody>
                            </table>:
                             (<span>Aucune pièce-jointe associée.</span>)
                          }
                            </div>
                        </CardBody>
                    </Card>
                    {/* :null
                    } */}
                </Row>

                <hr/>
                
                <Card className="mb-4" style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                  <CardBody>
                  <h4 className="text-center mt-2">Description de la ressource</h4>
                  <hr/>
                  <Row className="mt-4"> 
                    <label>Titre de la ressource </label>
                   
                    <Col md="12">
                      <Input
                        className="form-control"
                        type="text"
                        id="nom"
                        readOnly
                        onChange={this.handleChangeText}
                        // placeholder="Titre de la ressource"
                      />
                    </Col>
                  </Row>


                  <Row className="mt-4"> 
                   
                      
                    <Col md="12">
                        <label>Format </label>
                       
                        <Input
                          className="form-control owener-close"
                          type="text"
                          id="format"
                          readOnly
                          // placeholder="Titre de la ressource"
                        />

                        <select defaultValue={"0"}  onChange={this.handleChangeText}  className="form-select show" aria-label="Default select example" id="show-format">
                          <option value="0" selected>{$("#format").val()}</option>
                          {
                            this.state.formats.filter((e)=>e.label!==$("#format").val()).map(
                              (element,idx) =>(
                                  <option key={element.value} value={element.value}>{element.label}</option>
                              ))
                          }
                        </select>
                        
                    </Col>
                  </Row>


                  <Row className="mt-4"> 
                    <Col md="12">
                      <div className="docs-datepicker" 
                        data-toggle="tooltip" 
                        data-placement="top" 
                        data-html="true"
                        title="Vous devez renseigner au minimum 100 charactères et 600 charactères au maximum"
                      >
                        <label >Résumé de la ressource</label>
                        <textarea rows="8"  onChange={this.handleChangeText} className="form-control" maxlength="600" autofocus id="description"  readOnly />      
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md="12">
                      <label >Lien</label> 
                    
                      <div id="link" className="owener-close">
                        {
                          (this.state.url!=="")?
                        <p> <a href={this.state.ressource.url}>{this.state.url}</a></p>:
                        <p>Aucun lien disponible</p>
                        }
                      </div>
                      <div id="editerlien" className="show">
                        <Input
                          className="form-control"
                          type="text"
                          id="url"
                          defaultValue={this.state.url}
                          onChange={this.handleChangeText}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md="12">
                      <label>Date d'édition de la ressource</label>
                      <p>{this.state.dateD}</p> 
 
                      <div id="editerdate" className="show">
                        {/* <label>Dates d'édition de la ressource</label> */}
                        <div className="docs-datepicker" 
                          data-toggle="tooltip" 
                          data-placement="top" 
                          data-html="true"
                          title="Date d'édition de la ressource"
                        >
                          <InputGroup>
                            <Flatpickr
                              value={pick}
                              className="form-control d-block "
                              aria-label="Default select example"
                              placeholder="Choisissez la date d'édition de la ressource"
                              // id="datePub"
                              
                              options={{
                                locale:French,
                                // mode: "range",
                                maxDate:today,
                                altInput: true,
                                // enableTime: true,
                                // altFormat: "F j, Y",
                                altFormat: "d/M/Y"
                              }}
                              onChange={this.handleDateInterval}
                            />
                            <div className="input-group-append">
                              <button
                                type="button"
                                className="btn btn-outline-secondary docs-datepicker-trigger"
                                disabled
                              >
                                <i
                                  className="fa fa-calendar"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </InputGroup>
                          <div className="docs-datepicker-container" />
                        </div>
                      </div>
                    </Col>
                  </Row>
                
                  </CardBody>
                </Card>

                <Row className="mb-4">
                    
                  <Col md="12">
                    <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                    <CardBody>

                      <h4 className="text-center mt-2">Catégorisation de la ressource</h4>
                      <hr/>
                 
                      <Row className="mb-4">
                      <Col md="5">
                      <label>Type de ressource</label> 
                      
                      <Input
                        className="form-control owener-close"
                        type="text"
                        id="type_ressource"
                        readOnly
                        // placeholder="Type de la ressource"
                      />
                      <select defaultValue={"0"}  onChange={this.handleChangeType} className="form-select show" aria-label="Default select example" id="show-type-ressource">
                        {
                          this.state.type_ressources.map(
                            (element,idx) =>(
                              element.label===$("#type_ressource").val()?
                              <option key={element.value} value={element.value} selected>{$("#type_ressource").val()}</option>:

                              <option key={element.value} value={element.value}>{element.label}</option>
                            )
                          )
                        }
                      </select>
                    </Col>
                   
                    <Col md="5" className="show" id="soustypesystemeirrigation" >
                    { this.state.sous_type_ressources.length?
                      <>
                      <label>Sous-type(s) de ressource(s)</label>
                        <div  >
                        <ReactSelect
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isMulti
                          onChange={this.handleCheckSousSysteme}
                          options={this.state.sous_type_ressources}
                          placeholder="Choisir la/les sous-type(s) de ressource(s)"
                        />
                       
                       </div> 
                      </>:null
                        
                      }
                     </Col>
                  </Row>
                     
                      <div className=" mt-4">
                      <label>Sous-type(s) de ressource(s)</label>
                      {
                          (this.state.sous_type_ressource.length!=0)?
                          
                        <table className="table align-middle">
                          
                          <thead>
                            <tr>
                              <th>Libelle</th> <th>Sigle</th> <th>Description</th> {this.state.sous_type_ressource.length?<th  style={{display:this.state.hide}}>Action</th>:null}
                            </tr>
                          </thead>
                          <tbody>
                            {
                              
  
                              (this.state.sous_type_ressource.map(
                                (element,idx)=>(
                                  <tr>
                                  <td style={{ width: "30%" }}>
                                    <p className="mb-0">{element.libelle}</p>
                                  </td>
                                  <td style={{ width: "30%" }}>
                                    <p className="mb-0">{element.sigle}</p>
                                  </td>
                                  <td style={{ width: "30%" }}>
                                    <p className="mb-0">{element.description}</p>
                                  </td>
                                  <td style={{ width: "30%" }}>
                                    <a style={{display:this.state.hide}} onClick={this.handleDeleteSousType.bind(this,element.id)} ><strong>X</strong></a>
                                  </td>
                                </tr>
                                )
  
                              ))
                            }
                          </tbody>
                        </table>:
                          (<h6 className="mt-3">Aucun sous type de ressource associé.</h6>)
                          }
                          </div>
                      </CardBody>
                      </Card>
                    </Col>
                    
                  </Row>

                  <Row className="mb-4">
                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle className="mb-4 h4">Auteur(s) </CardTitle>
                    
                        <div id="auteur" className="show mt-4">
                         
                          <CreatableSelect
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            isMulti
                            onChange={this.handleCheckAuteur}
                            options={this.state.auteurs}
                            placeholder="Choisir ou ajouter le/les auteur(s)"
                          />
                        </div>
                        <div className=" mt-4">
                            <table className="table align-middle">
                                <tbody>
                                    
                                    {
                                    (this.state.auteur.length!=0)?
                                    (this.state.auteur.map(
                                        (element,idx)=>(
                                        <tr>
                                            <td style={{ width: "30%" }}>
                                                <p className="mb-0">{element.nom}</p>
                                            </td>
                                            <td style={{ width: "30%" }}>
                                                <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteAuteur.bind(this,element.id)} ><strong>X</strong></a>
                                            </td>
                                        </tr>
                                        )
                                       )
                                    ):(  <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">Aucun auteur</p>
                                        </td>
                                        
                                    </tr>)

                                    }

                                </tbody>
                            </table>
                            </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle  className="mb-4 h4 ">Langue(s)</CardTitle>
                        
                        <div id="langue" className="show mt-4">
                            <ReactSelect
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                onChange={this.handleCheckLangue}
                                options={this.state.langues}
                                placeholder="Choisir la/les langue(s)"F
                            />
                        </div>
                        <div className=" mt-4">
                            <table className="table align-middle">
                                <tbody>
                                
                                {
                                    (this.state.langue.length!=0) ?
                                    (this.state.langue.map(
                                        (element,idx)=>(
                                            <tr>
                                            <td style={{ width: "30%" }}>
                                                <p className="mb-0">{element.nom}</p>
                                            </td>
                                            <td style={{display:this.state.hide,width: "30%"}} className="owener2">
                                                <a style={{display:this.state.hide}} className="owener"  onClick={this.handleDeleteLangue.bind(this,element.id)} ><strong>X</strong></a>
                                            </td>
                                        </tr>
                                        )

                                    )):(  <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">Aucune langue associée.</p>
                                        </td>
                                        
                                    </tr>)

                                    } 

                                </tbody>
                            </table>
                            </div>
                        </CardBody>
                        </Card>
                    </Col>

                  </Row>



                <Row className="mb-4">
                    
                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle  className="mb-4 h4">Type(s) de système(s) irrigué(s)</CardTitle>
                      
                        <div id="typesystemeirrigation" className="show mt-4">
                            <ReactSelect
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                onChange={this.handleCheckSysteme}
                                options={this.state.irrigues}
                                placeholder="Choisir la/les type(s) de système(s) irrigué(s)"
                            />
                        </div>
                        <div className=" mt-4">
                          {
                            this.state.systeme.length?
                            <table className="table align-middle">
                                <thead>
                                    <tr>
                                        <th>Libelle</th> <th>Sigle</th> {this.state.systeme.length?<th style={{display:this.state.hide}}>Action</th>:null}
                                    </tr>
                                </thead>
                                <tbody>
                                    {

                                        (this.state.systeme.map(
                                            (element,idx)=>(
                                             <tr>
                                                <td style={{ width: "30%" }}>
                                                    <p className="mb-0">{element.libelle}</p>
                                                </td>
                                                <td style={{ width: "30%" }}>
                                                    <p className="mb-0">{element.sigle}</p>
                                                </td>
                                                <td style={{ width: "30%" }}>
                                                    <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteSysteme.bind(this,element.id)} ><strong>X</strong></a>
                                                </td>
                                            </tr>
                                            )

                                        ))

                                    }                              

                                </tbody>
                            </table>:
                            (<span>Aucun système d'irrigation associé.</span>)
                            }
                            </div>
                        </CardBody>
                        </Card>
                    </Col>
                    
                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle className="mb-4 h4">Thématique(s) </CardTitle>
                        
                        <div id="thematique" className="show mt-4">
                            <ReactSelect
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                onChange={this.handleCheckThematique}
                                options={this.state.thematiques}
                                placeholder="Choisir la/les thématique(s)"
                            />
                        </div>
                        <div className=" mt-4">
                            <table className="table align-middle">

                            {/* <thead>
                                    <tr>
                                        <th>Libelle</th>
                                    </tr>
                                </thead> */}
                                <tbody>
                                    
                                    {
                                    (this.state.thematique.length!=0)?
                                    (this.state.thematique.map(
                                        (element,idx)=>(
                                        <tr>
                                            <td style={{ width: "30%" }}>
                                                <p className="mb-0">{element.libelle}</p>
                                            </td>
                                            <td style={{ width: "30%" }}>
                                                <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteThematique.bind(this,element.id)} ><strong>X</strong></a>
                                            </td>
                                        </tr>
                                        )
                                       )
                                    ):(  <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">Aucune thématique associée.</p>
                                        </td>
                                        
                                    </tr>)

                                    } 

                                </tbody>
                            </table>
                            </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row>

                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle className="mb-4 h4e">Pays(s)</CardTitle>

                      
                        <div id="localisation" className="show mt-4">
                            <ReactSelect
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                   onChange={this.handleCheckLocalisation}
                                   options={this.state.localisations}
                                placeholder="Choisir la/les pays(s)"
                            />
                        </div>
                        <div className=" mt-4">
                          {
                            this.state.localite.length?
                            <table className="table align-middle">
                            <thead>
                                    <tr>

                                        <th>Code(s) du/des pays(s)</th> <th>Pays(s)</th> <th  style={{display:this.state.hide}}>Action</th> 

                                    </tr>
                                </thead>
                                <tbody>
                                    
                                {
                                
                                (this.state.localite.map(
                                    (element,idx)=>(
                                    <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">{element.code}</p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">{element.nom}</p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                            <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteLocalisation.bind(this,element.id)}><strong>X</strong></a>
                                        </td>
                                    </tr>
                                    )))
                                }
                                </tbody>
                            </table>:
                            (<span>Aucun pays associé.</span>)
                            }
                            </div>
                        </CardBody>
                        </Card>
                    </Col>

                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle  className="mb-4 h4">Unité(s) administrative(s)</CardTitle>
                        
                       
                          <div id="uniteadministrative" className="show mt-4">
                          { this.state.unites.length?
                            <ReactSelect
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                onChange={this.handleCheckUnite}
                                options={this.state.unites}
                                placeholder="Choisir la/les unité(s) administrative(s)"
                            />:null
                          }
                        </div>
                        <div className=" mt-4">
                        {   
                           (this.state.unite.length!=0)?
                            <table className="table align-middle">

                            <thead>
                                    <tr>
                                        <th>Libelle</th> <th>Code</th> {this.state.unite ?<th  style={{display:this.state.hide}}>Action</th>:null}
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                {
                                
                                (this.state.unite.map(
                                    (element,idx)=>(
                                    <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">{element.libelle}</p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">{element.code}</p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                            <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteUnite.bind(this,element.id)} ><strong>X</strong></a>
                                        </td>
                                    </tr>
                                    )))

                                

                                } 

                                </tbody>
                            </table>:
                            (<span>Aucune unité administrative associée.</span>)
                             }
                            </div>
                            </CardBody>
                        </Card>
                    </Col>

                </Row>

                <Row>
                  <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle className="mb-4 h4">Mot(s) clé(s)</CardTitle>
                       
                        <div id="motcle" className="show mt-4">
                          {/* <ReactSelect
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            isMulti
                            onChange={this.handleCheckMotCle}
                            options={this.state.motcles}
                            placeholder="Choisir la/les mot(s) clé(s)"
                          /> */}
                          <CreatableSelect
                            closeMenuOnSelect={false}
                            components={{Menu}}
                            isMulti
                            onChange={this.handleCheckMotCle}
                            isValidNewOption={isValidNewOption}
                            options={this.state.motcles}
                            placeholder="Choisir la/les mot(s) clé(s)"
                          />
                        </div>
                        <div className=" mt-4">
                            <table className="table align-middle">

                            <thead>
                                    {/* <tr>
                                        <th>Libelle</th>
                                    </tr> */}
                                </thead>
                                <tbody>
                                  
                                {
                                    (this.state.mot.length!=0)?
                                   
                                    (this.state.mot.map(
                                        (element,idx)=>(
                                            <tr>
                                            <td style={{ width: "30%" }}>
                                                <p className="mb-0">{element.libelle}</p>
                                            </td>
                                            <td style={{ width: "30%" }}>
                                                <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteMotCle.bind(this,element.id)} ><strong>X</strong></a>
                                            </td>
                                        </tr>
                                        )

                                    )):(  <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">Aucun mot-clé associé.</p>
                                        </td>
                                        
                                    </tr>)

                                    } 

                                </tbody>
                            </table>
                            </div>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle className="mb-4 h4">Type(s) d'accès</CardTitle>
                        
                        <div id="profile" className="show mt-4">
                          <Row className="mt-4"> 
                          {
                              !this.state.acces.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase()).length?
                            <Col md="6">
                              
                              <label>Choisissez le type d'accès</label>
                              <select className="form-select" onChange={this.handleChangeAcces} aria-label="Default select example" id="acces">
                                {/* <option selected>Choisir le type d'accès</option> */}
                                <option selected value="Public">Public</option>
                                <option value="Privé">Privé</option>
                              </select>
                             
                            </Col>:null
                             } 
                            <Col md="6" >
                              <div id="profiles" style={{display:this.state.acces.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase()).length?"block":"none"}}>
                              <label>Profil(s)</label>
                              <ReactSelect
                                  closeMenuOnSelect={false}
                                  components={animatedComponents}
                                  isMulti
                                  options={this.state.profile}
                                  placeholder="Choisir le/les profil(s)"
                                  onChange={this.handleChangeProfile} 
                                  aria-label="Default select example" 
                                  id="profile_id"
                                />
                            
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <div className=" mt-4">
                            <table className="table align-middle">

                            <thead>
                                   
                                </thead>
                                <tbody>
                                  
                                {
                                    (this.state.acces.length!=0)?
                                   
                                    (this.state.acces.map(
                                        (element,idx)=>(
                                            <tr>
                                            <td style={{ width: "30%" }}>
                                                <p className="mb-0">{element.libelle}</p>
                                            </td>
                                            <td style={{ width: "30%" }}>
                                                <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteProfile.bind(this,element.id)} ><strong>X</strong></a>
                                            </td>
                                        </tr>
                                        )

                                    )):(  <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">Aucun profil associé.</p>
                                        </td>
                                        
                                    </tr>)

                                    } 

                                </tbody>
                            </table>
                            </div>
                            </CardBody>
                        </Card>
                    </Col>
                    
                    
                </Row>

                
                <hr/>
                
                <Row className="mb-4">
                <h5 >Image(s)</h5>
               
                <Row>   
                  <Col md="12">
                    <Card className="show" id="show-image" style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                      <CardBody> 
                       
                        <Input
                          className="form-control"
                          type="file"
                          accept="image/*"
                          multiple 
                          placeholder="Pièce jointe"
                          id="image"
                          onChange={this.handleChangeText}
                        />
                      </CardBody>
                    </Card>
                  </Col> 
                </Row>
                   {
                    (this.state.image.length!=0)?
                    (
                      (this.state.image.map(
                          (element,idx)=>(
                            
                            <Col md="4" key={element.id}>
                                <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                                    <CardHeader style={{backgroundColor:"rgb(207 211 229)",borderTopLeftRadius:"30%",borderTopRightRadius:"30%"}}>
                                        <a onClick={this.handleDeleteImage.bind(this,element.id,element.name)} style={{display:this.state.hide}}><i className='bx bx-border bxs-trash bx-xs bx-pull-right'></i>  </a>
                                    </CardHeader>
                                    <CardBody>
                                        <img className="card-img-top" src={element.file}  alt="Image"/>
                                    </CardBody>
                                    
                                    <CardFooter style={{backgroundColor:"rgb(207 211 229)",borderRadius:"30%"}}>
                                        <small className="text-muted">{element.name}</small>
                                    </CardFooter>
                                </Card>
                            </Col>
                          )
                      ))
                    ):(<span>Aucune image associée.</span>)
                   }
                </Row>

                <hr/>
                
                <h5>Vidéo</h5>
               
                <Row>
                  <Col md="12">
                    <Card className="show" id="show-video" style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                      <CardBody>
                        <label>Ajouter un nouveau lien vidéo</label>
                        <div className="input-group">
                          <Input
                            className="form-control"
                            type="text"
                            placeholder="Vidéo"
                            id="video"
                            onChange={this.handleChangeText}
                          />
                          <div className="input-group-prepend  d-inline-block">
                            <span
                              className="input-group-text h-20"
                              id="validationTooltipUsernamePrepend"
                            >
                              <i className="bx bx-link"></i>
                            </span>
                          </div>
                        </div> 
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <div className="embed-responsive embed-responsive-16by9 mb-4">
                  { 
                    (this.state.video.length!=0)?
                    (
                      <iframe className="embed-responsive-item" src={this.state.video} height="400" width="900" allowfullscreen frameborder="4"></iframe>
                    ):(<span>Aucune vidéo associée.</span>)
                  }
                  {/* <iframe className="embed-responsive-item" src={this.state.video} height="400" width="900" allowfullscreen frameborder="4"></iframe> */}
                </div>

                <hr/>
                
                <hr></hr>

                <Row className="mb-5 mt-5">
                  <Col>
                    <PDFDownloadLink document={<DocumentPdf/>} fileName={"fiche-ressource"+this.state.ressource.id+".pdf"}>
                        <strong onClick={this.handleTelechargeIncrement}><h3> <i className="bx bxs-download bx-sm " style={{color:"#338C36"}}/> Télécharger la fiche de la ressource </h3></strong>
                    </PDFDownloadLink>
                  </Col>
                </Row>
              

                {this.state.validate_update?
                <Row>
                  <Col md="6">
                    <Button onClick={this.handleAnuler} style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}} >
                      Annuler
                    </Button>
                  </Col>
                  <Col md="6" >
                  
                    
                    {
                      this.state.chargement_data?
                      <Button id="chargement" style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                            Envoi...
                      </Button>:
                      <Button id="initial" onClick={this.handleUpdateRessource} style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                        Appliquer la modification
                      </Button>
                    }
                    
                  </Col>
                </Row>:null
                  }
            <hr/>
              <Row>
                  <Col md="12">
                    <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                    
                    <CardBody>
                      <h4 className="text-center mt-2">Évaluation de la ressource </h4>
                      <h4  style={{justifyContent:"center",alignContent:"right"}} className="text-center justify-content-center">
                     
                        {this.state.vote_avg}
                      </h4>
                      <hr/>
                      {this.state.profile_user?
                        <>
                            <CardTitle className="mb-1 mt-3 h4">Votre évaluation</CardTitle>
                            { this.state.commented?
                                <div className="docs-datepicker" 
                                  data-toggle="tooltip" 
                                  data-placement="top" 
                                  data-html="true"
                                  title="Faites votre commentaire"
                                >
                                  {/* <label >Votre commentaire</label> */}
                                  
                                  <textarea rows="8" className="form-control" onChange={e=>this.setState({commentaire:e.target.value})} maxlength="600" autofocus id="vote" value={this.state.commentaire}  />
                                </div>:null
                              }
                         
                        <Row className="mt-2">
                          <Col md="6">
                            <ReactStars
                              count={5}
                              onChange={ e=>
                                {
                                  $("#submiting").hide()
                                  $("#initial").show()
                                  this.setState({vote:e,commented:true})  
                                 
                                }
                                }
                              size={24}
                              activeColor="#ffd700"
                              value={this.state.vote}
                            />
                          </Col>
                          { this.state.commented?
                            <Col md="6">
                              <Button id="initial" onClick={this.handleVote} style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                                Envoyer
                              </Button>
                              {/* <Button 
                                id="submiting" 
                                color="success" 
                                className="b-lg"
                                style={{display:"none",backgroundColor:"#aad29a", borderColor:"#aad29a",borderRadius:"10px",float:"right"}}
                                type="button" disabled
                              >
                              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                                Envoi...
                              </Button> */}
                            </Col>:null
                          }
                        </Row>
                        </>:null
                        }

                        </CardBody>
                      
                      <CardBody>
                        <hr/>
                        <CardTitle className="mb-4 h4">Toutes les évaluations</CardTitle>
                        <MDBDataTable responsive sortable={false} style={{textAlign:"justify"}} striped bordered entries="5" entrieslabel="5" entriesOptions={this.state.entriesLabelList} maxHeight="200px" searching={false} data={vote} />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
            </div>
            </div>
             </>):(
        <div style={{marginTop:"250px",textAlign:"center"}}>
          <Spinner type="grow" color="secondary" />
        </div>
        )
        
      }
      </React.Fragment>
    )
  }
}

export default DetailRessource
